module.exports = __webpack_public_path__ + "static/img/graymore_pictgrid5_800x802.e12127b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/graymore_pictgrid5_800x802.jpg
// module id = WyhH
// module chunks = 0